import { render } from "./ExamCorrection.vue?vue&type=template&id=2551d09c"
import script from "./ExamCorrection.vue?vue&type=script&lang=js"
export * from "./ExamCorrection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__